import { setupWorker } from 'msw/browser';
import { http } from 'msw';
import { handlers as authHandlers } from '~/authentication/mocks/handlers';

export const worker = setupWorker(...authHandlers);

window.msw = {
  worker,
  http,
};
